const { PROD } = require("./constants/defaults");

export const enviroment = PROD; // Set PROD
